import CartItem from "Cart/store/models/cartItem";
import { namespace, actions, getters } from "Cart/store/store";
import { mapActions, mapGetters } from "vuex";
import { namespace as compareNamespace, actions as compareActions } from "Compare/store/store";

export default (options) => {
	return {
		el: "#vue-product",
		data: {
			id: options.id,
			count: 1
		},
		computed: {
			...mapGetters(namespace,
				{
					cartProducts: getters.cartProducts.name
				})
		},
		methods: {
			...mapActions(namespace,
				{
					addProductToCart: actions.addProductToCart.name,
					getProduct: actions.getProduct.name,
					updateProductCount: actions.updateProductCount.name
				}),
			...mapActions(compareNamespace,
				{
					addProductToDb: compareActions.addProductToDb.name
				}),
			productInCart: function (id) {
				let prod = this.cartProducts.findIndex(function (product) {
					return product.id === id;
				});

				return prod !== -1;
			},
			addToCard({ name, price, photo, code, url }) {
				let cartItem = new CartItem({
					id: this.id,
					productName: name,
					count: this.count,
					price: price,
					photo: photo,
					code: code,
					url: url
				});

				this.addProductToCart(cartItem);
			},
			updateCurrent() {
				this.updateProductCount({
					id: this.id,
					count: this.count
				});
			},
			addToCompare(id) {
				this.addProductToDb(id);
			}
		}
	};
};